import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('countries', [
      'countryNames',
      'allowedCountries',
      'cisCountries',
      'dhlCountries',
      'pksCountries'
    ]),
    countryOptions () {
      return this.allowedCountries.map(countryCode => {
        const formattedCode = countryCode.toUpperCase()

        return {
          name: `${this.countryNames[countryCode]} (${formattedCode})`,
          value: formattedCode
        }
      })
    }
  },
  methods: {
    getCountryName (countryCode) {
      if (countryCode != null && this.countryNames[countryCode.toUpperCase()]) {
        return this.countryNames[countryCode.toUpperCase()]
      }

      return countryCode
    },
    getCountryNames (countryCodes) {
      return countryCodes.reduce((countryNames, countryCode) => {
        const countryName = this.countryNames[countryCode.toUpperCase()] || countryCode

        return (countryNames) ? countryNames + ', ' + countryName : countryName
      }, '')
    }
  }
}
